/**
 * Removes Bootstrap modal artifacts (backdrop + body state) that can be
 * orphaned on <body> when a modal component is unmounted out-of-band
 * (route change, browser back/forward, logout…).
 *
 * No-op while a modal is still legitimately visible, so stacked modals keep
 * working.
 */
export function cleanupOrphanModalArtifacts(): void {
  if (document.querySelector(".modal.show")) {
    return;
  }
  document.querySelectorAll(".modal-backdrop").forEach((el) => el.remove());
  document.body.classList.remove("modal-open");
  document.body.style.removeProperty("overflow");
  document.body.style.removeProperty("padding-right");
}
